import { render, staticRenderFns } from "./inviteDesc.vue?vue&type=template&id=1747d988&scoped=true&"
import script from "./inviteDesc.vue?vue&type=script&lang=js&"
export * from "./inviteDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747d988",
  null
  
)

export default component.exports